<template>
  <div @click="closeAlertMessage()">
    <v-app id="app" :class="$route.meta.body_class">
        <Header v-if="login"/>
        <v-main class="white">
          <router-view/>
        </v-main>
        <Alert />
    </v-app>
  </div>
</template>
<script>
import Header from './components/Header'
import Alert from './components/Alert'
import { mapMutations } from "vuex";
export default {
  name: "App",
  components : {
    Header,
    Alert
  },
  data(){
    return {
      login : null
    }
  },
  methods :{    
    ...mapMutations("utils", ["setAlert"]),
    closeAlertMessage() {
      this.setAlert({
        show : false,
        variant : '',
        message : '',
        dismissCountDown : 0,
      });
    },
    // setWidth(){
    //   let fixedTopBar = document.getElementsByClassName('fixed-top-bar')      
    //   let mainClassWidth = document.getElementById('app').getBoundingClientRect().width
    //   fixedTopBar[0].style.width = (mainClassWidth - 110) + 'px'
    // }
  },
  mounted : function(){
    let _self = this
    setInterval(function(){
      _self.login = localStorage.getItem('token')      
    },100)
    // setInterval(() => {
    //   this.setWidth();  
    // },2000);  
  }
};
(function () { // make vuetify dialogs movable
    const d = {};
    document.addEventListener("mousedown", e => {
        const closestDialog = e.target.closest(".v-dialog.v-dialog--active");
        if (e.button === 0 && closestDialog != null && e.target.classList.contains("drag-icon")) { // element which can be used to move element
            d.el = closestDialog; // element which should be moved
            d.mouseStartX = e.clientX;
            d.mouseStartY = e.clientY;
            d.elStartX = d.el.getBoundingClientRect().left;
            d.elStartY = d.el.getBoundingClientRect().top;
            d.el.style.position = "fixed";
            d.el.style.margin = 0;
            d.oldTransition = d.el.style.transition;
            d.el.style.transition = "none"
        }
    });
    document.addEventListener("mousemove", e => {
        if (d.el === undefined) return;
        d.el.style.left = Math.min(
            Math.max(d.elStartX + e.clientX - d.mouseStartX, 0),
            window.innerWidth - d.el.getBoundingClientRect().width
        ) + "px";
        d.el.style.top = Math.min(
            Math.max(d.elStartY + e.clientY - d.mouseStartY, 0),
            window.innerHeight - d.el.getBoundingClientRect().height
        ) + "px";
    });
    document.addEventListener("mouseup", () => {
        if (d.el === undefined) return;
        d.el.style.transition = d.oldTransition;
        d.el = undefined
    });
    setInterval(() => { // prevent out of bounds
        const dialog = document.querySelector(".v-dialog.v-dialog--active");
        if (dialog === null) return;
        dialog.style.left = Math.min(parseInt(dialog.style.left), window.innerWidth - dialog.getBoundingClientRect().width) + "px";
        dialog.style.top = Math.min(parseInt(dialog.style.top), window.innerHeight - dialog.getBoundingClientRect().height) + "px";
    }, 100);
})();
</script>
<style>
html {
  overflow-y: auto;
}
/* #app {
  max-width : 812px;
  margin: 0 auto;
  max-height: 445px;
  height: 445px;
  margin-bottom: 30px !important;
  overflow-y: auto;
} */
.v-application--wrap{
  min-height: unset !important;
}
*::-webkit-scrollbar-track
{
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
	border-radius: 10px;
	background-color: #F5F5F5;
}

*::-webkit-scrollbar
{
	width: 12px;
	background-color: #F5F5F5;
}

*::-webkit-scrollbar-thumb
{
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
	background-color: #c5c5c5;
}

</style>
